<template>
    <div class="mini-basket shadow" :class="show ? '' : 'd-none'" id="mini-basket">
        <div v-if="basket">
            <div v-if="basket.total_quantity > 0">
                <div class="row">
                    <div v-if="addedProduct !== null && product !== null && !loading" class="col-12">
                        <div class="addedCard p-3 rounded mb-3">
                            <h4 class="text-white">Great, you've just added...</h4>
                            <h3 class="my-auto text-white">{{ product.name }}</h3>
                        </div>

                        <div v-if="promotionsNotInBasket.length > 0">
                            <h5 class="my-auto">This means you can now get...</h5>
                            <div v-for="promotion in promotionsNotInBasket" class="my-3">
                                <h2>{{ `${Math.round(promotion.discount)}% off ${promotion.name}` }}</h2>
                                <a :href="'/products/' + promotion.slug.slug"
                                   class="btn btn-secondary col-12">View product</a>
                            </div>
                            <a href="/basket" class="font-bold mt-3"><h4>No, thank you</h4></a>
                        </div>
                    </div>

                    <div v-else-if="!addedProduct && !loading" class="col-6">
                        <span>Items:</span>
                    </div>

                    <div v-if="addedProduct === null && !loading" class="col-6 justify-content-end">
                        <span class="d-block text-right">{{ basket.total_quantity }}</span>
                    </div>
                </div>

                <div v-if="addedProduct === null && !loading" class="row font-weight-bold">
                    <div class="col-6">
                        <span>Total:</span>
                    </div>

                    <div class="col-6 justify-content-end">
                        <span class="d-block text-right">£{{ basket.total|money }}</span>
                    </div>
                </div>

            </div>
            <div v-else>
                <p>You have no items in your basket.</p>
            </div>
        </div>

        <div v-if="loading" class="d-flex align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <a v-if="basket && !loading" href="/basket" class="btn btn-primary btn-block">View
            Basket
        </a>

        <div v-if="addedProduct !== null && product !== null && !loading" class="mt-3">
            <a :href="continueShoppingUrl" class="btn btn-primary btn-block">
                Continue Shopping
            </a>
        </div>


    </div>
</template>

<style>
.addedCard {
    background-color: #c18d6b;
}
</style>

<script>
export default {
    data() {
        return {
            product: null, // product that has been added to basket
            promotions: [],
            loading: false,
            school: null,
        };
    },

    props: {
        basket: {
            type: Object,
        },
        addedProduct: {
            type: Number,
            default: null
        },
        show: {
            type: Boolean,
            default: false,
        },
        authed: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        addedProduct() {
            this.getProduct();
        }
    },

    mounted() {

    },

    computed: {
        promotionsNotInBasket() {
            if (this.promotions && this.basket && this.basket.items) {
                const basketProductIds = this.basket.items.map(item => item.product_id);
                return this.promotions.filter(promo => {
                    return !promo.relevant_product_ids.some(id => basketProductIds.includes(id));
                });
            }
            return [];
        },
        continueShoppingUrl() {
            console.log(this.authed);
            return this.authed ? '/school-finder/shop' : '/categories';
        }
    },

    methods: {
        getProduct() {
            this.loading = true;
            if (this.addedProduct !== null) {
                axios.get('/api/v1/product/get/' + this.addedProduct).then((res) => {
                    if (res.data && res.data.success) {
                        this.product = res.data.product;
                        this.school = res.data.school;

                        if (res.data.promotions) {
                            this.promotions = res.data.promotions;
                        }

                        this.loading = false;
                    }
                })
            }
        }
    },
};
</script>
